export default __webpack_public_path__ + "static/media/procedure20230506.4ba27503.jpg";